<div class="row">
  <div class="col-md-12 col-sm-12 breadcumb-header">
    <div class="d-flex flex-row flex-wrap">
      <div class="d-flex flex-row align-items-center">
        <a class="not-underline first-line text-semi-bold-font" [routerLink]="['measure']"
           [queryParams]="{activeAccount: activeAccount}"
           queryParamsHandling="merge">{{'measure.root_menu' | translate}}</a>
        <img *ngIf="showReportList || canEditReport" src="assets/images/Arrow_Right.svg" width="20" height="11" class="breadcumb-seperate-arrow"/>
      </div>
      <div class="d-flex flex-row align-items-center flex-auto">
        <div class="report-name-field">
          <div *ngIf="showReportList" class="full-height full-width text-light-font">
            <div class="edit-report-name" [ngClass]="{'read-only': canEditReport === false}">
              <achoo-text-field #reportNameInputField
                                placeholder="{{'measure.report_name_placeholder' | translate}}"
                                (modelChange)="updateArrowPosition($event)"
                                [(model)]="selectReport.name">
              </achoo-text-field>
            </div>
            <achoo-filter-box #ReportSelection [hidden]="canEditReport"
                              [options]="reportList"
                              name="reportSelection"
                              (selectEvent)="onSelectReport($event)"
                              [(model)]="selectedReportId">
            </achoo-filter-box>
          </div>
          <div *ngIf="!showReportList" class="full-height full-width text-light-font">
            <div class="edit-report-name first-report" [ngClass]="{'hidden-report-name-field': !canEditReport}">
              <achoo-text-field #reportNameInputField
                                placeholder="{{'measure.report_name_placeholder' | translate}}"
                                (modelChange)="updateArrowPosition($event)"
                                [(model)]="selectReport.name">
              </achoo-text-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-12 col-sm-12 breadcumb-subheader">
    <span>{{'measure.sub_header' | translate}}</span>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-breadcumb/measure-breadcumb.component.html